import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { create, update } from '@/api/tiers';
import { create as createContact } from '@/api/contacts';
import { TIERS_SOUS_TYPE_BAILLEUR_PRIVE } from '@/configuration/tiers/tiersConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import store from '@/store/store';

function fillIntituleField(tiers) {
  if (tiers.adressePostale.ville !== null
    && tiers.adressePostale.ville.trim().length > 0
    && (tiers.adressePostale.intitule1 === null
      || tiers.adressePostale.intitule1.trim().length === 0)) {
    const isBailleurParticulier = tiers.sousTypes.find((sousType) => {
      return sousType === TIERS_SOUS_TYPE_BAILLEUR_PRIVE;
    });
    if (isBailleurParticulier) {
      if (tiers.civiliteId) {
        const civiliteFromStore = store.getters['parametres/parametre'](PARAMETRES_KEYS.civilite);
        const matchCivilite = civiliteFromStore.find((el) => el.id === tiers.civiliteId);
        tiers.civilite = matchCivilite;
      }
      tiers.adressePostale.intitule1 = [tiers.civilite?.libelle, tiers.nom]
        .filter(value => !!value).join(' ');
    } else tiers.adressePostale.intitule1 = tiers.nomCommercial;
  }
}

export async function insertTiers(tiers) {
  const copieTiers = cloneDeep(tiers);
  fillIntituleField(copieTiers);
  if (copieTiers.dateSignatureMandatSepa) {
    copieTiers.dateSignatureMandatSepa = moment(copieTiers.dateSignatureMandatSepa).format('YYYY-MM-DD');
  }
  if (copieTiers.dateNaissance) {
    copieTiers.dateNaissance = moment(copieTiers.dateNaissance).format('YYYY-MM-DD');
  }
  if (copieTiers.dateAnniversaireContrat) {
    copieTiers.dateAnniversaireContrat = moment(copieTiers.dateAnniversaireContrat).format('YYYY-MM-DD');
  }
  const response = await create(copieTiers);
  return response.data.result;
}

export async function updateTiers(tiers) {
  const tableContactsAInsertPromess = [];
  tiers.contacts.forEach((contact) => {
    if (!contact.id || contact.id === undefined) {
      contact.tiersId = tiers.id;
      tableContactsAInsertPromess.push(createContact(contact));
    }
  });
  await Promise.all(tableContactsAInsertPromess);
  tiers.contacts = [];
  const copieTiers = cloneDeep(tiers);
  fillIntituleField(copieTiers);
  if (copieTiers.dateSignatureMandatSepa) {
    copieTiers.dateSignatureMandatSepa = moment(copieTiers.dateSignatureMandatSepa).format('YYYY-MM-DD');
  }
  if (copieTiers.dateNaissance) {
    copieTiers.dateNaissance = moment(copieTiers.dateNaissance).format('YYYY-MM-DD');
  }
  if (copieTiers.dateAnniversaireContrat) {
    copieTiers.dateAnniversaireContrat = moment(copieTiers.dateAnniversaireContrat).format('YYYY-MM-DD');
  }
  const response = await update(copieTiers);
  const clientMisAJour = response.data.result;
  return clientMisAJour;
}
